import React from 'react';

const style = {
  backgroundColor: 'black',
  color: 'white',
  padding: 0,
  margin: 0,
  paddingTop: '15px',
};

const Notification = () => (
  <div className="row" style={style}>
    <div className="container">
      <p className="text-center">
        <strong>
          PURCHASE, LOGIN and REGISTER features are disabled as BusinessDNA Apps are not available anymore.
        </strong>
        <br />If you need help with your legacy installation, please get in touch through contact form or shoot us an
        email at support@businessdna.net.
      </p>
    </div>
  </div>
);
export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification.js